import React, { ReactElement } from 'react';
import { UpdatePunch } from 'records/interactions/UpdatePunch';
import UpdatePunchOverlay from './UpdatePunchOverlay';

interface Props {
  interaction: UpdatePunch;
}

const UpdatePunchOverlayWrapper = (props: Props): ReactElement => {
  const { interaction } = props;

  return (
    <UpdatePunchOverlay key={interaction.punch.id} interaction={interaction} />
  );
};

export default UpdatePunchOverlayWrapper;
